import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js";
import { 
    patchCuotasVentasActualizarValores,
    patchCuotasServiciosActualizarValores,
    patchCuotasEscriturasActualizarValores,
} from "../../../api/apicalls.js";
import {
    CATEGORIA_VENTA,
    CATEGORIA_SERVICIO,
    CATEGORIA_ESCRITURA,
    ACTUALIZACION_FIJO,
    ACTUALIZACION_PORCENTUAL,
} from "../constants.js"

import './ModalConfirmacion.scss';

class ModalConfirmacion extends Component {
    constructor(props) {
        super(props);
        this.state = { }
    }

    static propTypes = {
        fechaDesde: PropTypes.string.isRequired,
        compradorId: PropTypes.integer,
        loteoId: PropTypes.integer,
        loteId: PropTypes.integer,
        monedasId: PropTypes.arrayOf(PropTypes.integer),

        previewTotalCantidadCuotas: PropTypes.number.isRequired,
        categorias: PropTypes.arrayOf(
            PropTypes.oneOf([CATEGORIA_VENTA, CATEGORIA_SERVICIO, CATEGORIA_ESCRITURA])
        ).isRequired,
        tipoActualizacion: PropTypes.oneOf([ACTUALIZACION_FIJO, ACTUALIZACION_PORCENTUAL]).isRequired,
        valorActualizacion: PropTypes.number.isRequired,

        faltanCompletarParaConfirmar: PropTypes.arrayOf(PropTypes.string).isRequired,
        reset: PropTypes.func,
    }

    isConfirmacionDisabled = () => {
        const { faltanCompletarParaConfirmar } = this.props;
        return faltanCompletarParaConfirmar.length > 0;
    }

    onSubmit = () => {
        const {
            fechaDesde,
            compradorId,
            loteoId,
            loteId,
            monedasId,

            categorias,
            tipoActualizacion,
            valorActualizacion,

            reset,
        } = this.props

        // No se hace submit si está deshabilitado
        if (this.isConfirmacionDisabled()){
            return;
        }

        // Body del Request
        let body = {};
        body.fecha_desde = moment(fechaDesde).format('YYYY/MM/DD');
        if (compradorId){
            body.comprador_id = compradorId;
        }
        if (loteoId){
            body.loteo_id = loteoId;
        }
        if (loteId){
            body.lote_id = loteId;
        }
        if (monedasId){
            body.monedas_id = monedasId.toString();
        }
        body.tipo_actualizacion = tipoActualizacion;
        body.valor_actualizacion = valorActualizacion;

        // Request de cada categoria
        categorias.forEach(categoria => {
            if (categoria == CATEGORIA_VENTA){
                patchCuotasVentasActualizarValores(body);
            }

            if (categoria == CATEGORIA_SERVICIO){
                patchCuotasServiciosActualizarValores(body);
            }

            if (categoria == CATEGORIA_ESCRITURA){
                patchCuotasEscriturasActualizarValores(body);
            }
        })
        
        if (reset){
            reset()
        }
    }

    render() {
        const {
        } = this.state;

        const {
            previewTotalCantidadCuotas,
            faltanCompletarParaConfirmar,
        } = this.props;

        // Hackeo para deshabilitar el boton de confirmacion.
        const disabledBotonConfirmacion = () => false
        const enabledBotonConfirmacion = null
        let id = enabledBotonConfirmacion

        const missingIdMessage = (
            <div>
                Faltan completar los siguientes campos:
                <ul>
                    {faltanCompletarParaConfirmar.map(campoFaltante =>
                        <li key={campoFaltante}>{campoFaltante}</li>
                    )}

                </ul>
            </div>
        )

        if (this.isConfirmacionDisabled()){
            id = disabledBotonConfirmacion
        }

        return (
            <ParadigmaModal
                id={id}
                title="Confirmar Actualización"

                onSubmit={this.onSubmit}

                buttonTitle="Confirmar Actualización"
                buttonIcon="fa fa-check fa-lg"
                buttonClass="btn-success"

                missingIdMessage={missingIdMessage}
                successMessage="Cuotas Actualizadas"

                saveButton={true}
                saveButtonLabel="Actualizar"

                closeButton={true}
                cancelButtonLabel="Cancelar"
            >
                <div>
                {   
                    previewTotalCantidadCuotas == 1 &&
                    `se va a actualizar ${previewTotalCantidadCuotas} cuota`
                }
                {   
                    previewTotalCantidadCuotas != 1 &&
                    `se van a actualizar ${previewTotalCantidadCuotas} cuotas en total`
                }
                </div>
            </ParadigmaModal>
        );
    }
}

export default ModalConfirmacion;




// WEBPACK FOOTER //
// ./src/views/Cuotas/ActualizarValores/ModalConfirmacion.js